import Vue from "vue";
if(document.getElementById('stream-online')){
    let streamOnline = new Vue({
        el:'#stream-online',
        data: {
            users:{},
            load:true,
            sortKey:null,
            info: {},
            meta:{
                currentPage:0,
                pageCount:0,
                perPage:0,
                showFrom:0,
                showTo:0,
                totalCount:0
            }
        },
        mounted(){
            this.fetchUsers(1);
            this.getInfo();
            this.load = true;
        },
        methods:{
            getInfo(){
                let self = this;
                let params = {
                    id:lection_id
                };
                $.ajax({
                    url:'/api/v1/stream/statistic',
                    type: "GET",
                    data:params,
                    success:function (data){

                        self.info = data;


                    }
                });
                self.load = false;
            },
            sort(sort){
                if(this.sortKey === sort){
                    sort = '-'+sort;
                }

                this.sortKey = sort;

                this.fetchUsers(this.meta.currentPage,sort);
            },
            fetchUsers(page,sort){
                let self = this;
                sort = sort ? sort:this.sortKey;
                let params = {
                    page:page,
                    lection_id:lection_id,
                    sort:sort
                };
                $.ajax({
                    url:'/api/v1/stream/viewpoints',
                    type: "GET",
                    data:params,
                    success:function (data){

                        self.users = data.items;
                        self.meta = data._meta;

                        self.meta.showTo = self.meta.perPage * (self.meta.currentPage) > self.meta.totalCount ? self.meta.totalCount:self.meta.perPage * (self.meta.currentPage);

                        self.meta.showFrom =  self.meta.perPage * (self.meta.currentPage - 1);

                        self.load = false;

                    }
                });
                self.load = false;
            },
            pageUp() {
                $("html, body").animate({ scrollTop: 0 }, "slow");

            }
        },
        updated()  {
            this.$nextTick(function () {
                $('[data-toggle="tooltip"]').tooltip();
                $('[data-toggle="popover"]').popover();

            });
        }

    });


    let timerId = setInterval(function() {
        streamOnline.fetchUsers(streamOnline.meta.currentPage);
        streamOnline.getInfo();

    }, 1000 * 60);

}